/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Time/Content"
  
}) {
let eventAppointmentBookingLocalStartDateValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.local_start_date',
})
let eventAppointmentBookingLocalStartTimeValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.local_start_time',
})
let aggregateData = fromHelpers.formatDate(eventAppointmentBookingLocalStartDateValueData, eventAppointmentBookingLocalStartTimeValueData)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let eventAppointmentBookingLocalStartDateValueData1 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.local_start_date',
})
let eventAppointmentBookingLocalStartTimeValueData1 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.local_start_time',
})
let aggregateData1 = fromHelpers.formatYear(eventAppointmentBookingLocalStartDateValueData1, eventAppointmentBookingLocalStartTimeValueData1)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 weight="bold"
 color={dtColorsNeutral500}
 data="event.appointment.booking.local_start_date"
 data="event.appointment.booking.local_start_time"
 aggregate="helpers.js formatDate"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="semibold"
 color={dtColorsNeutral500}
 data="event.appointment.booking.local_start_date"
 data="event.appointment.booking.local_start_time"
 aggregate="helpers.js formatYear"
 text={aggregateData1}
/>
{children}
</React.Fragment>)
}